export enum Tabs {
	UI_UX = 'ui_ux',
	WEB = 'web',
	MOBILE = 'mobile',
	GRAPHIC = 'graphic'
}
